import { TranslateFunc } from '@ha/intl';
import {
  ListingKindTranslations,
  PropertyTypeTranslations,
  ListingTypeTranslations,
} from 'ha/models/Listing/translations';
import {
  ListingFacilities,
  ListingKind,
  ListingType,
} from '@ha/api/v2/types/Listing';

export interface MetaTitleArguments {
  T: TranslateFunc;
  type: ListingType;
  kind: ListingKind;
  isFurnished: boolean;
  facilities: ListingFacilities;
  price: string;
  city: string;
}

export function getMetaTitle({
  T,
  type,
  kind,
  isFurnished,
  facilities,
  price,
  city,
}: MetaTitleArguments): string {
  const isStudio = facilities.bedroom_count === '0';

  let prefix = T(ListingTypeTranslations[type]);
  if (kind !== ListingKind.EntirePlace) {
    prefix = isFurnished
      ? `${T('Furnished')} ${T('bedroom')}`
      : T(ListingKindTranslations[kind]);
  } else if (isStudio) {
    prefix = T(PropertyTypeTranslations.STUDIO);
  }

  return T('og.ldp.title', {
    kind: prefix,
    price,
    city,
  });
}
